import { createDecorator } from '../../instantiation/common/instantiation.js';
const IAccessibilitySignalService = ( createDecorator('accessibilitySignalService'));
export { IAccessibilitySignalService };
